import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CheckIncustomerAction } from "stores/CheckIn/CheckInCustomerAction";
import { VehicleAction } from "stores/vehicles/VehicleAction";
const mapStateToProps = (state) => {
    
  return {
    CheckIncustomerList: state.CheckIncustomerData.CheckIncustomerList,
    isLoading:state.CheckIncustomerData.CheckIncustomerTableLoading.isLoading,
    getModeldropdowndata:state.vehicleData.getModeldropdowndata,
    // addcheckindetails:state.CheckIncustomerData.addcheckindetails
    // getcheckinCustomerbyid:state.CheckIncustomerData.getcheckinCustomerbyid
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  CheckIncustomerAction: CheckIncustomerAction.getNavigationData,
  getVehicleModelData:VehicleAction.getVehicleModelData,
  postcheckindetailsData:CheckIncustomerAction.postcheckindetailsData,
  
  // getCheckinCustomerbyidData:CheckIncustomerAction.getCheckinCustomerbyidData
}, dispatch);

const CheckinStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default CheckinStore;
 